"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.link = void 0;
var colors_1 = require("./colors");
var defaultColor = colors_1.color.B6;
var contrastColor = colors_1.color.B3;
exports.link = {
    color: defaultColor,
    activeColor: defaultColor,
    decoration: 'none',
    contrastColor: contrastColor,
    contrastActiveColor: contrastColor,
    hover: {
        color: defaultColor,
        decoration: 'underline',
        contrastColor: contrastColor,
    },
};
//# sourceMappingURL=link.js.map